import React, {useState, useEffect, Fragment} from 'react';
import { viewProgramDetail } from '../../services/programService';
import { getCartItemsNonLoginUser, removeFromCartNonLoginUser } from '../../services/programService';
import { ProgramLoader } from '../reuse/SVG';
import Cartitems from './cartItems';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {getitemsincart} from '../../store/cart'

const NotLoginUserCart = (props) => {

    const[cartItems, setCartItems]                  = useState([]);
    const[loader, setloader]                        = useState(true);
    const[isDetailsConfirmed, setDetailsConfirmed]  = useState(0);

/***********Get item from local storge***************/

useEffect(() => {
    getCartItemsNonLoginUser().then((res)=>{
        if(res.data.statusCode===0)
        {
            setCartItems([]);
            setloader(false);       
        }
        else
        {
        setCartItems(res.data.responseData.result);
        let cartprograms = res.data.responseData.result;
        let detailsconfrimedCount = isDetailsConfirmed;
        cartprograms.map(items => {
            if(items.detailConfirmed===1)
            {
                detailsconfrimedCount++;
                setDetailsConfirmed(detailsconfrimedCount);
            }
        })
        setloader(false);
        }
    })
},[])  


const removeFromCart = async (cartId) =>{
    const removeItem =await removeFromCartNonLoginUser(`/?cartId=${cartId}`);
    try{
        let cartprducts = [...cartItems];
        let newcat = cartprducts.filter(cartitem => cartitem._id !== cartId);
        setCartItems(newcat);
        getCartItemsNonLoginUser().then(res=>{
            if(res?.data?.statusCode)
            {
                props.getitemsincart(res.data.responseData.result.length)
            }
        })
    }
    catch(err){} 
}


return(
    <Fragment>
        {
                <Fragment>
                    <div className="container">
                        <div className="d-flex align-items-center justify-content-between section_header">
                            <h2>Your Programs</h2>
                        </div>
                    </div>

                </Fragment>
            
        }

        {
            loader ?  <div className="program_loader"><ProgramLoader /></div> :
            cartItems.length > 0 ?
            cartItems.map((cartitem,i) => (
                    <Cartitems key={i} Item={cartitem} RemoveFromCart ={removeFromCart} />  
        ))
        :
        <div className="no_cart_item"><h3>Cart is Empty</h3></div>
        } 
           <div className='d-flex justify-content-end '>
            {
                isDetailsConfirmed >0 ? 
                <Link className="btn btn-primary rounded-0 me-2 mb-2 d-flex justify-content-end"   to={
                    {     
                        pathname: '/payment-confirmation'
                    }
                } >Proceed to Payment </Link> : ''
            } 
         </div>   
         
    </Fragment>
)
}

const mapDispatchToProps = dispatch => ({
    getitemsincart: (cartitems) => dispatch(getitemsincart(cartitems)),
});


export default connect(null, mapDispatchToProps)(NotLoginUserCart);